import React from "react";
import webui from "@tinqin/tinqin-web-ui";
import ResponsiveHOC from "./../../../HOC/components/responsive";
import { getAddressFromActions } from "./../../actions/page/PageAddress";

const Logo = props => {
    if (!props.data) {
        return webui.getUtils().getEmptyContent();
    }
    const onClick = e => {
        e.preventDefault();
        webui.getUtils().dispatchSirenActions(props, ["default", "click"]);
    };
    const dataProps = webui.getUtils().extractComponentProps(props, {
        additionalProps: ["image", "alt", "tag", "href", "title", "extraClasses"],
        propsDefaults: { tag: "div", extraClasses: "", title: "" }
    });

    const logoClass = "tq-logo " + dataProps.extraClasses;

    const actions = props.data.actions || [];
    const href = getAddressFromActions(actions);

    const properties = {
        className: logoClass,
        onClick,
        "data-tq-id": props.dataTqId
    };
    if (dataProps.href || href) {
        dataProps.tag = "a";
        properties.href = dataProps.href || href;
    }

    return React.createElement(
        dataProps.tag,
        properties,
        <div className="un-logo-container">
            <img src={dataProps.image} alt={dataProps.alt} title={dataProps.title} />
        </div>
    );
};

export default webui.connectComponent({
    actions: { dispatchSirenActions: "siren.dispatchSirenActions" }
})(ResponsiveHOC(Logo));
